import ArrowCircular from './src/arrow-circular-combined';
export default ArrowCircular;